const yearRange = [2025,2026,2027,2028,2029,2030,2031,2032,2033,2034];
export const commitmentClubYearRange = ['All',2026,2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018]

export default yearRange;
